import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle PL/SQL Training & Certification</h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/Oracle PLSQL.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h3>PL/SQL- Program with PL/SQL 11G & 12C</h3>
            <p>
              Oracle offers a complete, integrated set of application
              development tools that support any development approach,
              technology platform, or operating system. Oracle PL/SQL Developer
              Certified Associates demonstrate expertise in building
              database-centric Internet applications for both Oracle9i and
              Oracle Database 10g. Oracle Forms Developer Certified
              Professionals gain greater credibility, a higher level of
              efficiency, and improved job performance as application developers
            </p>
            <h4 style={{ color: "blue" }}>What you will learn</h4>
            <p>
              This course introduces students to PL/SQL and helps them
              understand the benefits of this powerful programming language. In
              the class, students learn to create PL/SQL blocks of application
              code that can be shared by multiple forms, reports, and data
              management applications. Students learn to create procedures,
              functions, packages, and database triggers. Students use iSQL*Plus
              to develop these program units. Students also learn to manage
              PL/SQL program units and database triggers, to manage
              dependencies, to manipulate large objects, and to use some of the
              Oracle-supplied packages.
            </p>
            <h4 style={{ color: "blue" }}>Prerequisites</h4>
            <p>Working with iSQL*Plus</p>
            <h3 style={{ color: "blue" }}>Course Topics</h3>
            <br />

            {/*  */}

            <h4>
            Introduction
            </h4>
            <ul>
              <li>Describing PL/SQL </li>
              <li>Describing the Use of PL/SQL for the Developer and the Database Administrator </li>
              <li>Explaining the Benefits of PL/SQL </li>
              <li>PL/SQL program constructs </li>
              <li>PL/SQL anonymous block structure </li>
              <li>Subprogram block structure </li>
              <li>Course objectives and overview </li>
            </ul>
            {/*  */}

            <h4>
            Declaring Variables
            </h4>
            <ul>
              <li>Recognizing the Basic PL /SQL Block and Its Sections </li>
              <li>Describing the Significance of Variables in PL/SQL </li>
              <li>Distinguishing Between PL/SQL and Non-PL/SQL Variables </li>
              <li>Declaring Variables and Constants </li>
              <li>Executing a PL/SQL Block </li>
            </ul>
            {/*  */}

            <h4>
            Writing Executable Statements
            </h4>
            <ul>
              <li>Recognizing the Significance of the Executable Section </li>
              <li>Writing Statements Within the Executable Section </li>
              <li>Describing the Rules of Nested Blocks </li>
              <li>Executing and Testing a PL/SQL Block </li>
              <li>Using Coding Conventions </li>
            </ul>
            {/*  */}

            <h4>
            Interacting with the Oracle Server
            </h4>
            <ul>
              <li>Writing a Successful SELECT Statement in PL/SQL </li>
              <li>Declaring the Data type and Size of a PL/SQL Variable Dynamically </li>
              <li>Writing Data Manipulation Language (DML) Statements in PL/SQL </li>
              <li>Controlling Transactions in PL/SQL </li>
              <li>Determining the Outcome of SQL DML Statements </li>
            </ul>
            {/*  */}

            <h4>
            Writing Control Structures
            </h4>
            <ul>
              <li>Identifying the Uses and Types of Control Structures </li>
              <li>Constructing an IF Statement </li>
              <li>Constructing and Identifying Different Loop Statements </li>
              <li>Controlling Block Flow Using Nested Loops and Labels </li>
              <li>Using Logic Tables </li>
            </ul>
            {/*  */}

            <h4>
            Working with Composite Data types
            </h4>
            <ul>
              <li>Creating User-Defined PL/SQL Records </li>
              <li>Creating a PL/SQL Table </li>
              <li>Creating a PL/SQL Table of Records </li>
              <li>Differentiating Among Records, Tables, and Tables of Records </li>
            </ul>
            {/*  */}

            <h4>
            Writing Explicit Cursors
            </h4>
            <ul>
              <li>Using a PL/SQL Record Variable </li>
              <li>Distinguishing Between the Implicit and Explicit Cursor </li>
              <li>Writing a Cursor FOR Loop </li>
            </ul>
            {/*  */}

            <h4>
            Advanced Explicit Cursor Concepts
            </h4>
            <ul>
              <li>Writing a Cursor that Uses Parameters</li>
              <li>Determining When a FOR UPDATE Clause in a Cursor Is Required </li>
              <li>Using a PL/SQL Table Variable </li>
              <li>Using a PL/SQL Table of Records </li>
            </ul>
            {/*  */}

            <h4>
            Handling Exceptions
            </h4>
            <ul>
              <li>Defining PL/SQL Exceptions </li>
              <li>Recognizing Unhandled Exceptions </li>
              <li>Listing and Using Different Types of PL/SQL Exception Handlers </li>
              <li>Trapping Unanticipated Errors </li>
              <li>Describing the Effect of Exception Propagation in Nested Blocks </li>
              <li>Customizing PL/SQL Exception Messages </li>
            </ul>
            {/*  */}

            <h4>
            Creating Procedures
            </h4>
            <ul>
              <li>Describe the uses of procedures </li>
              <li>Create procedures </li>
              <li>Create procedures with arguments </li>
              <li>Invoke a procedure </li>
              <li>Remove a procedure </li>
            </ul>
            {/*  */}

            <h4>
            Creating Functions
            </h4>
            <ul>
              <li>Describe the uses of functions </li>
              <li>Create a function </li>
              <li>Invoke a function </li>
              <li>Remove a function </li>
              <li>Differentiate between a procedure and a function </li>
            </ul>
            {/*  */}

            <h4>
            Managing Subprograms
            </h4>
            <ul>
              <li>Describe system privilege requirements </li>
              <li>Describe object privilege requirements </li>
              <li>Query the relevant data dictionary views </li>
              <li>Debug subprograms </li>
            </ul>
            {/*  */}

            <h4>
            Creating Packages
            </h4>
            <ul>
              <li>Describe packages and list their possible components </li>
              <li>Create packages that include public and private subprograms, as well as global and local variables </li>
              <li>Invoke objects in a package </li>
              <li>Remove packages </li>
            </ul>
            {/*  */}

            <h4>
            More Package Concepts
            </h4>
            <ul>
              <li>Write packages that use the overloading feature of PL/SQL </li>
              <li>Avoid errors with mutually referential subprograms </li>
              <li>Initialize variables with a one-time-only procedure </li>
              <li>Specify the purity level of packaged functions </li>
              <li>Describe the persistent state of packaged variables, cursors, tables, and records </li>
              <li>Query the relevant data dictionary views </li>
            </ul>
            {/*  */}

            <h4>
            Using Oracle-Supplied Packages
            </h4>
            <ul>
              <li>Overview of Oracle-supplied packages </li>
              <li>View examples of some supplied packages </li>
              <li>Write dynamic SQL </li>
            </ul>
            {/*  */}
            <h4>
            Creating Database Triggers
            </h4>
            <ul>
              <li>Describe different types of triggers </li>
              <li>Describe database triggers and their use </li>
              <li>Create database triggers </li>
              <li>Describe database trigger firing rules </li>
              <li>Drop database triggers </li>
            </ul>
            {/*  */}
            <h4>
            More Trigger Concepts
            </h4>
            <ul>
              <li>Create triggers that fire when certain database actions occur </li>
              <li>List some of the limitations of database triggers </li>
              <li>Determine when to use database triggers or Oracle Server features </li>
              <li>Create triggers by using alternative events (notINSERT/UPDATE/DELETE) </li>
              <li>Create triggers by using alternative levels (not STATEMENT/ROW) </li>
              <li>Query the relevant data dictionary views </li>
            </ul>
            {/*  */}
            <h4>
            Managing Dependencies
            </h4>
            <ul>
              <li>Overview of object dependencies </li>
              <li>Manage PL/SQL objects for recompilation </li>
            </ul>
            {/*  */}
            <h4>
            Manipulating Large Objects
            </h4>
            <ul>
              <li>Compare and contrast LONG/RAW/LONG RAW with large objects (LOBs) </li>
              <li>Understand LOBs </li>
              <li>Manage binary large file objects (BFILEs) </li>
              <li>Use PL/SQL with an LOB </li>
              <li>Create a table with LOB columns </li>
              <li>Manipulate LOBs </li>
              <li>Use DBMS_LOB Oracle-supplied packages </li>
              <li>Create a temporary LOB </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
